import { render } from "./PaymentApprovalsView.vue?vue&type=template&id=41a9fe63"
import script from "./PaymentApprovalsView.vue?vue&type=script&lang=js"
export * from "./PaymentApprovalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__